import { BellRing } from "lucide-react";
import { formatDate } from "../lib/format";

const STATO_LBL = { aperta: "Aperta", chiusa: "Chiusa", in_lavorazione: "In lavorazione" };

// Campanellino rosso: mostrato se il soggetto è presente in altre pratiche.
// Hover -> popup con l'elenco (numero, data apertura, stato).
export default function SoggettoBell({ pratiche, onOpen, testId }) {
  if (!pratiche || pratiche.length === 0) return null;
  return (
    <span className="relative inline-flex group align-middle ml-1.5" data-testid={testId} onClick={(e) => e.stopPropagation()}>
      <BellRing className="h-3.5 w-3.5 text-red-500 cursor-help" />
      <span className="hidden group-hover:block absolute left-0 top-full z-50 pt-1.5">
      <span className="block w-64 rounded-md border border-slate-700 bg-[#121824] shadow-xl p-2 text-left normal-case">
        <span className="block text-[10px] uppercase tracking-wider text-red-400 font-mono mb-1">Presente anche in {pratiche.length} pratica/che</span>
        {pratiche.map((pr) => (
          <button key={pr.id} type="button" onClick={(e) => { e.stopPropagation(); onOpen && onOpen(pr); }} data-testid={`${testId}-item`} title="Apri la pratica"
            className="w-full text-left px-1.5 py-1 rounded hover:bg-slate-800/70 flex items-center justify-between gap-2 cursor-pointer">
            <span className="font-mono text-amber-400 text-xs underline decoration-dotted underline-offset-2 hover:text-amber-300">{pr.numero_pratica || "—"}</span>
            <span className="text-[10px] text-slate-400">{pr.data_apertura ? formatDate(pr.data_apertura) : "—"} · {STATO_LBL[pr.stato] || pr.stato || "—"}</span>
          </button>
        ))}
      </span>
      </span>
    </span>
  );
}
